import {createApp} from 'vue'
import ProjectCard from './ProjectCard'

const el = '.kb-component--project-card'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((ProjectCardDOM)=>{
            const result = JSON.parse(ProjectCardDOM.dataset.result)
            const component = createApp(ProjectCard, { result }).use(Store)
            component.mount(ProjectCardDOM)
        })
    }
}